import React from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Menu from '../../components/Menu/Menu';
import HeroSection from '../../components/HeroSection/HeroSection';
import AboutSection from '../../components/AboutSection/AboutSection';
import BestSellersSection from '../../components/BestSellersSection/BestSellersSection';
import NewSection from '../../components/NewSection/NewSection';
import OrderSection from '../../components/OrderSection/OrderSection';
import SliderSection from '../../components/SliderSection/SliderSection';
import SweetSection from '../../components/SweetSection/SweetSection';
import './Home.css';

const Home = () => {
  return (
    <>
      <Header />
      <Menu />
      <main>
        <HeroSection />
        <SliderSection />
        <NewSection />
        <AboutSection />
        <BestSellersSection />
        <SweetSection />

        <OrderSection />
      </main>
      <Footer />
    </>
  );
};

export default Home;